import StarIcon from '@common/assets/icons/star.svg?react';
import { Card, type CardProps } from '@common/ui/Card';

import styles from './TariffCard.module.scss';

export interface TariffCardProps extends CardProps {
  name: string;
  price: number;
  /** Price currency; 'RUB' renders ₽, anything else keeps the Stars icon. */
  currency?: string;
  oldPrice?: number;
  discount?: number;
}

export const TariffCard = ({
  name,
  price,
  currency,
  oldPrice,
  discount,
  ...props
}: TariffCardProps) => {
  return (
    <Card {...props} className={styles.tariffCard}>
      <div className={styles.name}>{name}</div>
      <div className={styles.price}>
        <div className={styles.priceValue}>
          {currency === 'RUB' ? (
            <>{price} ₽</>
          ) : (
            <>
              <StarIcon style={{ marginRight: 4 }} /> {price}
            </>
          )}
        </div>
        {oldPrice && <div className={styles.oldPrice}>{oldPrice}₽</div>}
      </div>
      {discount && <div className={styles.discount}>Скидка {discount}%</div>}
    </Card>
  );
};
